import useParams from '../../../hooks/useParamsAndCookies';
import { POLICY_STATUS, PolicyFiltersOptions } from './PolicyFilters';

const parseStatus = (value: string) =>
  POLICY_STATUS.some((status) => status.value === value) ? value : undefined;

const PolicyParams = () => {
  useParams<PolicyFiltersOptions>({
    tab: 'POLICY',
    params: [{ label: 'policyStatus', parse: parseStatus }],
    cookieFiltersName: 'insuranceFilters',
    cookiePath: '/insurance',
  });

  return <span />;
};

export default PolicyParams;
